<template>
  <div style="max-height: 500px;">
    <canvas :id="id" height="300px"></canvas>
  </div>
</template>

<script>
import axios from "axios";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register the plugin correctly for Chart.js v2
Chart.plugins.register(ChartDataLabels);

export default {
  name: "school-general-chart",
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: "canvas"
    },
    type: {
      type: String,
      default: "pie" // Default to pie chart
    },
    legend: {
      type: Boolean,
      default: true // Default to pie chart
    },
    query: {
      type: String,
      default: ""
    },
    search: {
      type: Object,
      default: () => {}
    },
    label: {
      type: Array,
      default: () => []
    },
    labelField: {
      type: String,
      default: null
    },
    indexField: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      chartInstance: null,
      chartData: [],
      chartLabel: [],
      chartColor: [],
      title: "",
    };
  },

  watch: {
    query() {
      this.getData();

    },
    search: {
      handler(newVal, oldVal) {
        this.getData();
      },
      deep: true
    },
    label(data) {
      this.chartLabel = [];
      this.chartColor = [];
      data.forEach(item => {
        this.chartLabel.push(item.label);
        this.chartColor.push(item.color);
      });
    }
  },

  created() {
    this.getData();
    //
  },

  methods: {
    async getData() {
      try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/chart/query?query=${this.query}`, this.search);
        this.initChart();
        this.chartData = [];
        this.chartLabel = [];
        if(response.listPeriod1.length === 0) {
          this.title = "Không có dữ liệu";
          return;
        }
        // response.listPeriod1.forEach(rs => {
        //   this.chartLabel.push(rs[this.labelField]);
        //   this.chartData.push(rs[this.indexField]);
        // });
        this.chartData1 = response.listPeriod1;
        this.chartDataTotal = response.listPeriod2;
        // this.chartData3 = response.listPeriod3;

        // this.chartData1 = [30, 46, 46]
        // this.chartDataTotal = [100, 100, 100]
        this.chartData2 = this.chartData1.map((val, idx) => {
          return this.chartDataTotal[idx] - val;
        });

        this.maxValue = response.listPeriod2[0] + 10;
        //this.chartData = this.chartData;

        this.title = "Báo cáo dữ liệu tổng quan";
        this.createChart();
      } catch (error) {
        console.error("Error fetching chart data:", error);
      }
    },

    initChart() {
      this.chartLabel = [];
      this.chartColor = [];
      this.label.forEach(item => {
        this.chartLabel.push(item.label);
        this.chartColor.push(item.color);
      });
    },

    createChart() {
      const ctxmark = document.getElementById(this.id).getContext("2d");

      // Destroy old chart instance before creating a new one
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      this.chartInstance = new Chart(ctxmark, {
        type: 'horizontalBar',
        data: {
          labels: ["Level 3", "Level 2", "Level 1"],
          datasets: [
            {
              label: "Completed",
              data: this.chartData1,
              backgroundColor: ["#0A1A64", "#3A4DA2", "#AEB9FF"],
              stack: 'progress'
            },
            {
              label: "Remaining",
              data: this.chartData2, // total - completed
              backgroundColor: "#FFFFFF",
              stack: 'progress'
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: "Tỉ lệ hoàn thành bài học trung bình",
            fontSize: 16,
            fontColor: "black"
          },
          legend: {
            display: false
          },
          tooltips: {
            enabled: false
          },
          scales: {
            xAxes: [{
              stacked: true,
              ticks: {
                beginAtZero: true,
                max: this.maxValue,
              }
            }],
            yAxes: [{
              stacked: true,
              categoryPercentage: 0.8, // ✅ Tăng khoảng cách giữa các cột
              barPercentage: 0.5  ,
            }]
          },
          plugins: {
            datalabels: {
              anchor: (context) => {
                return context.datasetIndex === 0 ? "center" : "end";
              },
              align: (context) => {
                return context.datasetIndex === 0 ? "center" : "end";
              },
              offset: (context) => {
                return context.datasetIndex === 0 ? 0 : 8;
              },
              formatter: (value, context) => {
                const datasetIndex = context.datasetIndex;
                const index = context.dataIndex;

                if (datasetIndex === 0) {
                  return value; // show number in filled section
                }
                // Calculate percentage
                const completed = context.chart.data.datasets[0].data[index];
                const total = completed + value;
                const percent = Math.round((completed / total) * 100);

                return percent + "%"; // show % in white section
              },
              color: (context) => {
                return context.datasetIndex === 0 ? "#fff" : "#000";
              },
              font: {
                weight: "bold",
                size: 12
              }
            }
          }
        }
      });
    }
  }
};
</script>
